export function Upsert(organizationID: number, formID: number): string {
	return `/v1/organizations/${organizationID}/forms/${formID}/agreements`;
}

